import { Component, OnDestroy, OnInit } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-average-purchase-time',
  templateUrl: './average-purchase-time.component.html',
  styleUrl: './average-purchase-time.component.scss'
})
export class AveragePurchaseTimeComponent implements OnInit, OnDestroy {
  constructor(private dashboardService: DashboardService,) { }
  private unsubscribe$ = new Subject<void>()
  noData: boolean;
  dynamicContent: string;

  ngOnInit(): void {
    this.dashboardService.buyerStatsData.pipe(takeUntil(this.unsubscribe$)).subscribe(result => {
      this.noData = !result.avgPurchaseTime;
      if (result.avgPurchaseTime > 0) {
        this.dynamicContent = `
          <div>${this.transform(result.avgPurchaseTime)}</div>`;
      }
    })
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  transform(value: number): string {
    if (value === 0) {
      return "0";
    }
    const totalSeconds = Math.floor(value * 60);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    if (value > 60) {
      return `${hours}h ${minutes}m ${seconds}s`;
    } else {
      return `${minutes}m ${seconds}s`;
    }

  }
}
